/**
 * A navegação de PÁGINA INTEIRA na mesma aba — sair do melidash para a tela de autorização de um provedor e voltar
 * pela Redirect URL (Health → Conexões, retorno automático). Mora aqui, numa função só, para que a tela não dependa
 * de `window.location` direto: o jsdom dos testes não navega, e quem testa a tela troca esta função.
 */
export function NavigateSameTab(url) {
    window.location.assign(url);
}
